export default "__VITE_ASSET__131ee4f1__"